var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tent"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.71635 17.0328L16 12.8435L22.2838 17.0328H31.3973L16 4.42529L0.602661 17.0328H9.71635Z",
    fill: "#806A50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.0625 15.7222L10.8997 18.4975L10.2015 27.5745H15.0625V15.7222Z",
    fill: "#806A50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.0124 18.9077L23.6791 27.5743H32V18.9077H23.0124Z",
    fill: "#806A50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.1003 18.4974L16.9375 15.7222V27.5745H21.7985L21.1003 18.4974Z",
    fill: "#806A50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.98763 18.9077H0V27.5743H8.32094L8.98763 18.9077Z",
    fill: "#806A50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTent);
export default __webpack_public_path__ + "static/media/Tent.55f1bdcda26c947f80b4bca6ea56bd76.svg";
export { ForwardRef as ReactComponent };